import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../store/actions';
import { updateQuestionDetails } from '../Utils/questionDetailsUpdater';
import { DEFAULT_RESPONSE_DETAILS } from '../const';

const useQuestionDetailsUpdater = (
  mcqIds,
  sections,
  currentSectionId,
  questionDetails,
  progress,
  mcqsResponses,
) => {
  const dispatch = useDispatch();

  const responseDetails = DEFAULT_RESPONSE_DETAILS;

  useEffect(() => {
    // Determine which MCQs to use based on sections
    let currentMcqIds = mcqIds;
    if (sections && sections.length > 0 && currentSectionId) {
      const currentSection = sections.find(section => section.id === currentSectionId);
      if (currentSection && currentSection.mcqs) {
        currentMcqIds = currentSection.mcqs.map(mcqId => ({ id: mcqId }));
      }
    }

    if (
      currentMcqIds &&
      currentMcqIds.length > 0 &&
      (!questionDetails || questionDetails.length !== currentMcqIds.length)
    ) {
      const newQuestionDetails = updateQuestionDetails(
        currentMcqIds,
        mcqsResponses,
        responseDetails,
      );
      dispatch(actions.setQuestionDetails(newQuestionDetails));
      dispatch(actions.setProgress({ ...progress, total: currentMcqIds.length }));
    }
  }, [mcqIds, sections, currentSectionId, questionDetails, dispatch, progress, mcqsResponses]);
};

export default useQuestionDetailsUpdater;
